import { BReactComponent } from 'blocks-cloud/b-react-component';
import { BackToRoot } from 'reactApp/ui/BackToRoot/BackToRoot';

export default function backtocloudroot(): void {
    const node = document.querySelector('#react-back-to-cloud-root');

    if (node) {
        const component = new BReactComponent({
            ReactComponent: BackToRoot,
            renderMode: 'append',
        });

        component.renderTo(node);
    }
}
